import { ExamResult } from '@/interfaces/examResult';
import { UserExamResultFilters } from '@/interfaces/filters/userExamResultFilters';
import { ListResponse } from '@/interfaces/list';
import { ExamResultResource, examResultResource } from '@/resources/examResult.resource';
import { EntityModule } from '../entity.module';

/**
 * Moduł wyników egzaminu użytkownika
 *
 * @export
 * @class ProfileExamResultModule
 * @extends {EntityModule<ExamResult, ExamResultResource>}
 */
export class ProfileExamResultModule extends EntityModule<ExamResult, ExamResultResource> {
  constructor() {
    super(examResultResource);

    this.actions = {
      ...this.actions,
      /**
       * Pobiera liste wyników egzaminu
       *
       * @param context context
       * @param filters filtry listy
       */
      list: (context: any, filters: UserExamResultFilters): Promise<void> => {
        filters.profileId = context.rootState.profile.id;
        return this.resource.userExamResultList(filters).then(({ list, count }: ListResponse<ExamResult>) => {
          context.commit('saveList', list);
          context.commit('saveCount', count);
        });
      }
    };
  }
}

export default new ProfileExamResultModule();
